import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button } from 'rsuite';
import { StyledTitleText } from '@/dashboard/components/add-chart-modal-styles';
import {
  ChartSelectionModal,
  connectTranslations,
} from './chart-selection-modal';

@connectTranslations
export class PrintChartModal extends ChartSelectionModal {
  // Overriding useless constructor b/c it is passing props to parent
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  StyledAddButton = () => (
    <ReactToPrint
      trigger={() => <Button color="blue">Print</Button>}
      content={() => this.printableContent.current}
    />
  );

  ModalTitle = () => <StyledTitleText title="Print chart" />;
}
